// extracted by mini-css-extract-plugin
export default {"wrapper":"yA-z","viewport":"zA-z","container":"AA-z","slide":"BA-z"};